(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printlits-christmas-quotes"] && !Shopify.designMode) return;
  try {
    
function hydratePrintlitsReviews() {
  document.querySelectorAll('[data-printlits-review-images]').forEach(section => {
    const template = section.querySelector('[data-review-source]');
    const track = section.querySelector('.pl-final-reviews__track');
    const sourceReviews = template?.content.querySelectorAll('.jdgm-carousel-item');
    if (!sourceReviews?.length || !track) return;
    const set = document.createElement('div');
    set.className = 'pl-final-reviews__set';
    sourceReviews.forEach(source => {
      const body = source.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim();
      if (!body) return;
      const card = document.createElement('figure');
      card.className = 'pl-final-review';
      const stars = document.createElement('div');
      stars.className = 'pl-final-review__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', source.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label') || '');
      stars.textContent = '★★★★★';
      const quote = document.createElement('blockquote');
      quote.textContent = body;
      card.append(stars, quote);
      const sourceImage = source.querySelector('.jdgm-carousel-item__product-image');
      if (sourceImage) {
        const url = sourceImage.getAttribute('data-src-retina') || sourceImage.getAttribute('data-src') || sourceImage.getAttribute('src');
        if (url && url.startsWith('https://')) {
          const image = document.createElement('img');
          image.className = 'pl-final-review__product';
          image.src = url;
          image.alt = sourceImage.getAttribute('alt') || '';
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';
          card.append(image);
        }
      }
      const author = document.createElement('figcaption');
      author.textContent = source.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || '';
      card.append(author);
      set.append(card);
    });
    if (!set.children.length) return;
    const copy = set.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    track.replaceChildren(set, copy);
  });
}
hydratePrintlitsReviews();
document.addEventListener('shopify:section:load', hydratePrintlitsReviews);

  } catch(e) { console.error(e); }
})();
})();
